<template>
  <span>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
            v-bind="attrs"
            v-on="on"
            text
            icon @click="loadFaq()"><v-icon color="primary">mdi-frequently-asked-questions</v-icon>
        </v-btn>
      </template>
      <span>{{ $t('buttons.Learn more') }}</span>
    </v-tooltip>

    <v-dialog
        v-model="faqDialog"
        transition="dialog-top-transition"
        max-width="600"
    >
      <v-card class="faq">
        <v-toolbar
            color="primary"
            dark
        ><div v-if="faq" class="text-h6">{{ faq.question }}</div></v-toolbar>
        <v-card-text class="mt-6">
          <div v-if="faq">
            <div v-html="faq.answer"></div>
            <vimeo-player v-if="faq.video_id" ref="player" :video-id="faq.video_id" @ready="onReady" class="player-container mt-6" :options="options"></vimeo-player>
          </div>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn
              color="primary"
              elevation="0"
              @click="faqDialog = false"
          >{{ $t('buttons.Close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>

</template>

<script>
import axios from "axios";
import {i18n} from "../i18n";

export default {
  name: "FaqTooltip",
  props: ['id'],
  data: () => ({
    options: {'responsive': true, 'dnt': true},
    playerReady: false,
    faq: null,
    faqDialog: false,
  }),
  methods: {
    loadFaq() {
      const instance = axios.create({
                baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
                headers: {'Accept-Language': i18n.locale}
              });

              instance
                  .get('/api/faqs/' + this.id)
          .then(response => {
            this.faq = response.data.data
            this.faqDialog = true
          })
          .catch(error => {
            console.log(error)
          })
          .finally(() => {
            window.prerenderReady = true;
          })
    },
    onReady() {
      this.playerReady = true
    },
    play () {
      this.$refs.player.play()
    },
    stop () {
      this.$refs.player.stop()
    },
  }
}
</script>

<style>
  .faq {
    border-radius: 10px;
  }
  .faq p, .faq li {
    font-size: 1rem!important;
    font-weight: 400;
    line-height: 1.5rem;
    letter-spacing: .03125em!important;
    font-family: Roboto,sans-serif!important;
  }
  .faq ul, .faq ol {
    margin-bottom: 16px;
  }
  .faq p {
    margin-bottom: 0;
  }
  .player-container {
    width: 100% !important;
  }
</style>
